import React from 'react';
import {Body} from '@lightricks/react-design-system';
import styles from './CampaignBadge.module.scss';

type CampaignBadgeProps = {
  campaignName: string;
  testID?: string;
};

function CampaignBadge({
  campaignName,
  testID = 'campaign-badge',
}: CampaignBadgeProps) {
  return (
    <div className={styles.badge} data-testid={testID}>
      <Body size="sm" className={styles.badgeText}>
        {campaignName}
      </Body>
    </div>
  );
}

export default CampaignBadge;
